(function ($) {
  const formId = $('.form-container').data('form');
  const formContainer = document.querySelector('.form-container');

  const loadMarketoForm = function () {
    if (!window.MktoForms2) {
      let s = document.createElement('script');
      s.src = "https://go.premise.com/js/forms2/js/forms2.min.js";

      s.onload = function () {
        $(`#mktoForm_${formId}`).children().remove();
        MktoForms2.loadForm("//go.premise.com", "870-CRW-973", formId, function () {
          // Callback function content
        });
      };

      document.body.appendChild(s);
    } else {
      MktoForms2.loadForm("//go.premise.com", "870-CRW-973", formId, function () {
        // Callback function content
      });
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Check if the observed entry is intersecting (visible)
      if (entry.isIntersecting) {
        loadMarketoForm();

        // Optional: Stop observing the element after it becomes visible and the form is loaded
        observer.unobserve(formContainer);
      }
    });
  }, {
    // Optional: Adjust these options to control when the callback is invoked
    root: null, // observes the element in relation to the viewport
    rootMargin: '0px', // margin around the root
    threshold: 0.1 // percentage of the target's visibility the observer's callback should execute
  });

  // Start observing the `.form-container`
  if (formContainer) {
    observer.observe(formContainer);
  }
})(jQuery);
